import React from "react";
import { GeneralInfoTabEditMode } from "../GeneralInfoTabEditMode";
import { GeneralInfoTabAutoPatrol } from "../GeneralInfoTabAutoPatrol";
import { SchedulesTabEditMode } from "../SchedulesTabEditMode";
import { RecordingServerTabEditMode } from "../RecordingServerTabEditMode";
import { Dispatcher } from "./siteAboutInterfaces";
import { CameraHealthTabEditMode } from "../CameraHealthTabEditMode";
import { WebhooksTab } from "../WebhooksTab";
import WebhooksTabEditMode from "../WebhooksTabEditMode";
import { useSiteAboutStore } from "../siteAboutStore/siteAboutStore";
import { EvalinkTabEditMode } from "../EvalinkTabEditMode";
import {
  WireGuardTabEditMode,
  WireGuardEditSession,
} from "../WireGuardTabEditMode";
import { WireGuardTunnel } from "./siteAboutInterfaces";
import { DOUBLE_TAKE_TAB } from "./siteDoubleTake";

export const handleEditInformationButtonClick = (
  clickedTab: any,
  setEditMode: any,
  setActiveTab: any,
  setPatchObject: any,
  setSiteInfo: any,
  vmsVariables: any,
  setVmsVariables: any,
  siteSchedules: any,
  siteInfo: any,
  setSiteSchedules: any,
  setBackdropLoadingScreenOn: any,
  editMode: any,
  setSchedulesTabActive: any,
  setClickedTab: any,
  setAlertState: any,
  setSyncNeeded: any,
  setSiteInfoChangesMade: any,
  setScheduleChangesMade: any,
  setDeleteScheduleDialogOpen: any,
  recordingServerData: any,
  recordingServerPatchObject: any,
  setRecordingServerPatchObject: any,
  setRecordingServerChangesMade: Dispatcher<boolean>,
  healthCheckData: any,
  setCameraHealthPatchObject: any,
  setCameraHealthChangesMade: Dispatcher<boolean>,
  setAddCameraHealthDialogOpen: Dispatcher<boolean>,
  setTurnOffHealthDialogOpen: Dispatcher<boolean>,
  webhooksInfo: any,
  setWebhooksPatchObject: any,
  setWebhooksChangesMade: any,
  setSiteInfoBackup: any,
  setVmsVariablesBackup: any,
  setSiteSchedulesBackup: any,
  setFlexScheduleOnEditButtonClick: Dispatcher<boolean>,
  showWireguardTab: boolean,
  wireguardTunnels: WireGuardTunnel[],
  selectedWireguardTunnelId: number | null,
  setSelectedWireguardTunnelId: React.Dispatch<
    React.SetStateAction<number | null>
  >,
  onWireGuardSessionUpdate: (session: WireGuardEditSession) => void,
  setWireguardChangesMade: Dispatcher<boolean>
) => {
  localStorage.setItem("flexSchedulingChanged", "false");

  const { autoPatrolScheduleHealthchckMetrics, autoPatrolSchedules } =
    useSiteAboutStore.getState();

  setSiteInfoBackup(siteInfo);

  setVmsVariablesBackup(vmsVariables);

  setSiteSchedulesBackup(siteSchedules);

  if (siteInfo.has_flex_schedule) {
    setFlexScheduleOnEditButtonClick(true);
  }

  if (!siteInfo.has_flex_schedule) {
    setFlexScheduleOnEditButtonClick(false);
  }

  localStorage.setItem("backUpSiteSchedule", JSON.stringify(siteSchedules));

  localStorage.setItem(
    "backupAutoPatrolScheduleHealthchckMetrics",
    JSON.stringify(autoPatrolScheduleHealthchckMetrics)
  );

  localStorage.setItem(
    "backupAutoPatrolSchedules",
    JSON.stringify(autoPatrolSchedules)
  );

  const isAutoPatrol = siteInfo?.integration_type_name === "autopatrol";

  if (clickedTab === "one") {
    setEditMode(true);

    if (isAutoPatrol) {
      // For AutoPatrol sites, backup is already in Zustand store
      setActiveTab(<GeneralInfoTabAutoPatrol editMode={true} />);
    } else {
      setActiveTab(
        <GeneralInfoTabEditMode
          setPatchObject={setPatchObject}
          setSiteInfo={setSiteInfo}
          siteInfo={siteInfo}
          setSiteInfoChangesMade={setSiteInfoChangesMade}
          vmsVariables={vmsVariables}
          setVmsVariables={setVmsVariables}
        />
      );
    }
  } else if (clickedTab === "three") {
    setEditMode(true);
    setActiveTab(
      <SchedulesTabEditMode
        siteInfo={siteInfo}
        setEditMode={setEditMode}
        setSiteInfo={setSiteInfo}
        setActiveTab={setActiveTab}
      />
    );
  } else if (clickedTab === "five") {
    setEditMode(true);
    setActiveTab(
      <RecordingServerTabEditMode
        recordingServerData={recordingServerData}
        recordingServerPatchObject={recordingServerPatchObject}
        setRecordingServerPatchObject={setRecordingServerPatchObject}
        setRecordingServerChangesMade={setRecordingServerChangesMade}
      />
    );
  } else if (clickedTab === "six") {
    setEditMode(true);
    setActiveTab(
      <CameraHealthTabEditMode
        healthCheckData={healthCheckData}
        setCameraHealthPatchObject={setCameraHealthPatchObject}
        setCameraHealthChangesMade={setCameraHealthChangesMade}
        siteInfo={siteInfo}
        setAddCameraHealthDialogOpen={setAddCameraHealthDialogOpen}
        setTurnOffHealthDialogOpen={setTurnOffHealthDialogOpen}
      />
    );
  } else if (clickedTab === "seven") {
    // Pending edits are keyed by webhook id (ENG-2233); start clean.
    setWebhooksPatchObject({});
    setWebhooksChangesMade(false);
    setEditMode(true);
    setActiveTab(
      <WebhooksTabEditMode
        webhooksInfo={webhooksInfo}
        setWebhooksPatchObject={setWebhooksPatchObject}
        setWebhooksChangesMade={setWebhooksChangesMade}
      />
    );
  } else if (clickedTab === "eight") {
    setEditMode(true);
    setActiveTab(<EvalinkTabEditMode />);
  } else if (clickedTab === "nine" && showWireguardTab) {
    setEditMode(true);
    setWireguardChangesMade(false);
    setActiveTab(
      <WireGuardTabEditMode
        wireguardTunnels={wireguardTunnels}
        selectedTunnelId={selectedWireguardTunnelId}
        onSelectTunnelId={(id) => setSelectedWireguardTunnelId(id)}
        onSessionUpdate={onWireGuardSessionUpdate}
        setWireguardChangesMade={setWireguardChangesMade}
      />
    );
  } else if (clickedTab === DOUBLE_TAKE_TAB) {
    // SiteAbout renders the DoubleTake tab itself and passes editMode down.
    setEditMode(true);
  }
  setSchedulesTabActive(false);
};
